<template>
  <b-modal
    id="modal-multi-3"
    size="lg"
    title="GENERADOR DE SLOTS"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showModalHorarios"
    no-close-on-backdrop
    @hidden="close"
  >
    <b-row>
      <b-col md="10">
        <v-select
          v-if="!isCreando"
          v-model="configuracionSelected"
          :options="listConfiguraciones"
          placeholder="Seleccione el generador"
          :clearable="false"
          @input="changeConfig(configuracionSelected)"
        />
        <div v-if="isCreando" class="form-label-group">
          <b-form-input
            id="floating-institucion"
            placeholder="Ingrese descripción breve(ejemplo: generador maxima primera y segunda) *"
            v-model="nombreConfig"
            style="text-transform: uppercase"
          />
          <label for="floating-institucion">Institución *</label>
        </div>
      </b-col>
      <b-col md="2">
        <b-button
          v-if="
            (!isCreando && USER().rol === ROLES.SUPER) ||
              USER().rol === ROLES.ADMIN ||
              USER().rol === ROLES.TECNICA
          "
          v-b-tooltip.hover.v-primary
          title="Nueva configuración"
          variant="flat-primary"
          class="btn-icon"
          @click="getDataHorariosBlank"
        >
          <feather-icon size="22" icon="PlusCircleIcon" />
        </b-button>
        <b-button
          v-if="
            isCreando &&
              (USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA)
          "
          v-b-tooltip.hover.v-primary
          title="Salir modo creación"
          variant="danger"
          class="btn-icon"
          @click="salirModoCreacion"
        >
          Salir modo creacion
        </b-button>
      </b-col>
    </b-row>
    <b-row class=" cabecera-tabla mt-1"
      ><b-col md="3">Categorias </b-col>
      <b-col md="9">
        <b-row>
          <b-col md="3" class="p-0 text-center">Dias</b-col>
          <b-col md="2" class="p-0 text-center">H.Inicial</b-col>
          <b-col md="2" class="p-0 text-center">H.Final</b-col>
          <b-col md="2" class="p-0 ">Intervalo</b-col>
          <b-col md="2" class="p-0 ">#Canchas</b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-overlay
      :show="showLoading"
      rounded="sm"
      :class="[showLoading ? 'mt-1' : 'mt-0', '']"
    >
      <b-row>
        <b-col md="3">
          <b-form-checkbox
            v-for="option in listCategorias"
            :key="option.value"
            v-model="categoriasModel"
            :value="option.value"
            name="flavour-3a"
            style="margin: 10px;"
          >
            {{ option.text }}
          </b-form-checkbox>
        </b-col>
        <b-col md="9" style="background:#ededed">
          <div v-for="item in listDias" :key="item.id_fixture_dias">
            <b-row class="m-1">
              <b-col md="3">
                <b-form-checkbox
                  v-model="item.activo"
                  :disabled="
                    USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TECNICA
                      ? false
                      : true
                  "
                >
                  <span>{{ item.dia }}</span>
                </b-form-checkbox>
              </b-col>
              <template v-if="item.activo">
                <b-col md="2" class="p-0">
                  <cleave
                    id="time"
                    v-model="item.inicial"
                    class="form-control cleave-estilo"
                    style="height:25px"
                    :raw="false"
                    :options="time"
                    placeholder="hh:mm"
                    :disabled="
                      USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.TECNICA
                        ? false
                        : true
                    "
                  />
                </b-col>
                <b-col md="2" class="p-0">
                  <cleave
                    id="time"
                    v-model="item.final"
                    class="form-control cleave-estilo"
                    style="height:25px"
                    :raw="false"
                    :options="time"
                    placeholder="hh:mm"
                    :disabled="
                      USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.TECNICA
                        ? false
                        : true
                    "
                  />
                </b-col>
                <b-col md="2" class="p-0">
                  <cleave
                    id="time"
                    v-model="item.intervalo"
                    class="form-control cleave-estilo"
                    style="height:25px"
                    :raw="false"
                    :options="time"
                    placeholder="hh:mm"
                    :disabled="
                      USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.TECNICA
                        ? false
                        : true
                    "
                  />
                </b-col>
                <b-col md="2" class="p-0">
                  <cleave
                    id="time"
                    v-model="item.canchas"
                    class="form-control cleave-estilo"
                    style="height:25px"
                    :raw="false"
                    :options="{
                      blocks: [1],
                      numericOnly: true,
                    }"
                    placeholder="#canchas"
                    :disabled="
                      USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.TECNICA
                        ? false
                        : true
                    "
                  />
                </b-col>
              </template>
            </b-row>
          </div>
          <div style="text-align:center">
            <b-button
              v-if="categoriasModel.length != 0"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              @click="vistaPreviaSlots"
            >
              Generar vista previa de slots
            </b-button>
            <p class="mensaje-guardar" v-if="showMensajeGuardar && isCreando">
              La vista previa a sido creada correctamente, puede cerrar la
              ventana para revisar los slots creados. Una vez que la
              configuración sea de su agrado puede regresar a esta pantalla y
              presionar GUARDAR para usar la configuración realizada
              posteriormente
            </p>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1"
        @click="close"
      >
        Cerrar
      </b-button>
      <b-button
        v-if="isCreando && !showLoadingGuardar"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right"
        @click="saveSlots"
      >
        Guardar
      </b-button>
      <div v-if="showLoadingGuardar" class="text-center mt-1">
        <b-spinner variant="primary" label="Text Centered" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BRow,
  BCol,
  VBTooltip,
  BFormCheckbox,
  BFormInput,
  BOverlay,
  BSpinner,
  // BSpinner,
  // xxx,
  // xxxx,
  // sss,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { computed, ref } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BButton,
    vSelect,
    BRow,
    BCol,
    BFormCheckbox,
    Cleave,
    BFormInput,
    BOverlay,
    BSpinner,
  },

  directives: {
    'b-tooltip': VBTooltip,
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    isOpen: Boolean,
    listCategorias: Array,
    listDias: Array,
    showLoading: Boolean,
    categoriasSeleccionadas: Array,
    listConfiguraciones: Array,
    isCreando: Boolean,
  },
  setup(props, { emit }) {
    // console.log(props)
    // const listCategorias = ref([])
    // const listDias = ref([])
    // const categoriasSeleccionadas = ref([])
    const listPreviaDias = ref([])
    const listPreviaFranjas = ref([])
    const configuracionSelected = ref(null)
    const nombreConfig = ref(null)
    const showMensajeGuardar = ref(false)
    const showLoadingGuardar = ref(false)
    // const isCreando = ref(false)
    const time = ref({
      time: true,
      timePattern: ['h', 'm'],
    })
    const { postApi } = apiCall()
    const categoriasSeleccionadasObjetos = computed(
      () =>
        // eslint-disable-next-line
        props.listCategorias.filter(
          // eslint-disable-next-line
          c =>
            // eslint-disable-next-line
            props.categoriasSeleccionadas.includes(c.value),
          // eslint-disable-next-line
        ),
      // eslint-disable-next-line
    )
    const categoriasModel = computed({
      get() {
        return props.categoriasSeleccionadas
      },
      set(value) {
        emit('updateCategoriasSeleccionadas', value)
      },
    })
    function close() {
      store.commit('someVariables/UPDATE_SHOW_MODAL_HORARIOS', false)
      if (!props.isCreando) {
        emit('cierraHorario')
        showMensajeGuardar.value = false
        configuracionSelected.value = null
      }
    }
    function changeConfig(item) {
      nombreConfig.value = item.label
      emit('changeConfig', item)
    }
    function getDataHorariosBlank() {
      // console.log(grupoClick)
      nombreConfig.value = null
      emit('getDataHorariosBlank')
      // listCategorias.value = []
      // listDias.value = []
      // props.isCreando = true
      // showLoading.value = true
      // const path = `ApiConfiguration/getUtilsHorarios/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
      // const data = await getApi(URL, path)
      // listCategorias.value = data.categorias
      // listDias.value = data.dias
      // showLoading.value = false
    }
    async function vistaPreviaSlots() {
      // console.log(props.categoriasSeleccionadas)
      // console.log(categoriasModel.value)
      // console.log(categoriasSeleccionadasObjetos.value)
      const data = {
        // dias: props.listDias,
        dias: props.listDias.filter(dia => dia.activo === true),
        categorias: props.categoriasSeleccionadas,
        nombre: nombreConfig.value,
        id_fixture_configuracion: configuracionSelected.value,
      }
      // console.log(data)
      const path = 'ApiFixture/crearSlotsApi'
      const response = await postApi(URL, path, data)
      if (response.flag === 'no') {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: response.mensaje,
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          },
        )
      } else {
        showMensajeGuardar.value = true
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Vista previa creada exitosamente',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          },
        )
        listPreviaDias.value = response.dias
        listPreviaFranjas.value = response.franjas_aux
        emit('vistaPrevia', {
          dias: listPreviaDias.value,
          franjas: listPreviaFranjas.value,
          categorias: categoriasSeleccionadasObjetos.value,
          franjasSend: response.franjas,
          id_fixture_configuracion: configuracionSelected.value,
        })
      }

      // console.log(response)
    }
    function salirModoCreacion() {
      configuracionSelected.value = null
      nombreConfig.value = null
      emit('inicializaVariables')
      // listCategorias.value = []
      // listDias.value = []
    }
    async function saveSlots() {
      showLoadingGuardar.value = true
      const data = {
        dias: props.listDias,
        categorias: props.categoriasSeleccionadas,
        nombre: nombreConfig.value,
        id_fixture_configuracion: configuracionSelected.value,
      }
      // console.log(data)
      const path = 'ApiConfiguration/insertFixtureConfiguracion'
      const response = await postApi(URL, path, data)
      if (response.flag === 'no') {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: response.mensaje,
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
            // eslint-disable-next-line
          },
        )
      } else {
        // salirModoCreacion()
        configuracionSelected.value = null
        nombreConfig.value = null
        showMensajeGuardar.value = false
        emit('cerrarModoCreacion')
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'GUARDADO con éxito',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          },
        )
      }
      showLoadingGuardar.value = false
      // emit('vistaPrevia', {
      //   dias: props.listDias,
      //   categorias: props.listCategorias,
      //   nombre: nombreConfig.value,
      //   id_fixture_configuracion: configuracionSelected.value,
      // })
      // console.log(response)
    }

    return {
      close,
      USER,
      ROLES,
      getDataHorariosBlank,
      time,
      vistaPreviaSlots,
      configuracionSelected,
      saveSlots,
      nombreConfig,
      salirModoCreacion,
      categoriasModel,
      changeConfig,
      showMensajeGuardar,
      showLoadingGuardar,
    }
  },
}
</script>
<style scoped>
.cleave-estilo {
  font-size: 11px;
  width: 80%;
}
.cabecera-tabla {
  background: rgb(67 67 67);
  font-size: 13px;
  font-weight: bolder;
  box-decoration-break: clone;
  color: azure;
  padding: 4px;
  border-radius: 2px;
}
.mensaje-guardar {
  background: cornsilk;
  border-radius: 5px;
  margin-top: 5px;
  font-size: 12px;
  padding: 3px;
  font-weight: 400;
}
</style>
